import {getProfCourseFromCourse} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useLoadProfCourseById(id: number) {
  return useLoad(getProfCourseFromCourse, ['iD_Course', 'iD_ProfileSpac'], {
    id,
  });
}

export default useLoadProfCourseById;
